module.exports = __webpack_public_path__ + "static/img/join-06.13b3c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join-06.png
// module id = Beqr
// module chunks = 10